// extracted by mini-css-extract-plugin
export default {"navbarSec":"navbar_navbarSec__W1sLd"};